import React, { useState, useEffect } from "react";
import NormalTable from "../../../components/common/Tables/NormalTable";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PulseLoader } from 'react-spinners';
import { ToastContainer } from "react-toastify";
import FormattedDate from "../../../components/common/DateFormat/FormattedDate";
import {createUser,getUser,getAllVenueBySlug,deleteUser,updateUser} from "../../../api"
import ListCard from "../../../components/common/ListCard/ListCard";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { stat } from "fs";
const AddNewUser = () => {
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    const [user, setUser] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [eventVenues, setEventVenues] = useState<any[]>([]);
    const [eventVenuesForAdd, setEventVenuesForAdd] = useState<any[]>([]);
    const [selectedVenueForAdd, setSelectedVenueForAdd] = useState<string>("");
    const [editModal, setEditModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [showPassword, setShowPassword] = useState(false);
    const toggleEditModal = () => setEditModal((prev) => !prev);
    useEffect(() => {
      getUserList();
    if (modal) {
        getEventVenue();
      }
    }, [modal]);
    const getUserList = async () => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const organizerId = JSON.parse(eventData).organizerId;
          const eventId = JSON.parse(eventData).eventId;
          const response = await getUser(organizerId);
          if (response) {
              const filteredUsers = response.filter(
                (user:any) => user.venue?.event?.eventId === eventId
              );
            setUser(filteredUsers);
          }
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setIsLoading(false);
      }
    };
    const getEventVenue = async () => {
        try {
          setIsLoading(true);
          const eventData = localStorage.getItem("eventData");
          if (!eventData) return;
          const slugId = JSON.parse(eventData).slugId;
          const resp = await getAllVenueBySlug(slugId);
          const venueOptions = resp.map((item: any) => {
            return {
              value: item.venueId,
              label: item.venueName
            } 
          })
          setEventVenuesForAdd(venueOptions);
          if (venueOptions.length === 1) {
          formik.setFieldValue("venue", venueOptions[0].value);
          setSelectedVenueForAdd(venueOptions[0].value);
        }
          const allVenue = {
            value: "0",
            label: "All Venues"
          }
          setEventVenues([allVenue, ...venueOptions])
        } catch (error) {
          console.error("Error fetching event venues:", error);
        }
        finally{
          setIsLoading(false);
        }
      };
    const formik = useFormik({
      initialValues: {
        name: '',
        email: '',
        phoneNo: '',
        venue: '', 
        password: '',
        eventSlug: '',
        organizerId: '', 
        status: 'active',  
      },
    validationSchema: Yup.object({
        name: Yup.string().required('Name is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        phoneNo: Yup.string().required('Phone number is required'),
        venue: Yup.string().required('Venue is required'), 
        // profileImage: Yup.mixed().required('Profile image is required'),
        password: Yup.string().min(6, 'Password must be at least 6 characters long').required('Password is required'),
    }),
       onSubmit: async (values) => {
        try {
          const organizerData = localStorage.getItem("organizerData");
          const eventData = localStorage.getItem("eventData");
          if (organizerData && eventData) {
            const organizerId = JSON.parse(organizerData).organizerId;
            const eventSlug = JSON.parse(eventData).slugId;
            const payload = {
              eventSlug: eventSlug,
              organizerId: organizerId,
              name: values.name,
              email: values.email,
              phoneNo: values.phoneNo,
              venueId: values.venue,
              password: values.password,
              status: values.status,
            };
            
        
              await createUser(organizerId, payload);
            toast.success("User added successfully");
            setModal(false);
            getUserList();
            formik.resetForm();
          } else {
            toast.error("Missing event or organizer data");
          }
        } catch (error) {
          console.error("Failed to create user:", error);
          toast.error("Failed to add user");
        }
      }
        });
        const editFormik = useFormik({
          initialValues: {
            phoneNo: '',
            status: 'active',
          },
          enableReinitialize: true,
          validationSchema: Yup.object({
            phoneNo: Yup.string().required("Phone number is required"),
            status: Yup.string().oneOf(["active", "inactive"], "Invalid status").required("Status is required"),
          }),
          onSubmit: async (values) => {
            try {
              if (!selectedUser) return;
              const organizerData = localStorage.getItem("organizerData");
              const organizerId = JSON.parse(organizerData || "{}").organizerId;

              const payload = {
                phoneNo: values.phoneNo,
                status: values.status,
              };

              await updateUser(selectedUser.userId, payload); 
              toast.success("User updated successfully");
              toggleEditModal();
              getUserList();
            } catch (error) {
              console.error("Error updating user:", error);
              toast.error("Failed to update user");
            }
          },
        });

    const columns = [
      { label: "Name", key: "name" },
      { label: "Email", key: "email" },
      { label: "Phone No", key: "phoneNo" },
      { label: "Venue", key: "venueName" ,
        cellContent: (row: any) => {
          return row.venue ? row.venue.venueName : "N/A";
        }
      },
      { label: "Created At", key: "createdAt",
        cellContent: (row: any) => <FormattedDate dateString={row?.createdAt} />
       },
      { label: "Status", key: "status", cellContent: (row: any) => <span className={row?.status === "active" ? "text-success" : "text-danger"}>{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}</span> },
      {
        label: "Action",
        key: "edit",
        cellContent: (row: any) => (
          <span
            className="d-flex justify-content-center align-items-center gap-4 cursor-pointer"
            onClick={() => {
              setSelectedUser(row);
              editFormik.setValues({
                phoneNo: row.phoneNo,
                status: row.status,
              });
              toggleEditModal();
            }}
          >
            <i className="fa-solid fa-pen-to-square text-primary" title="Edit"></i>
          </span>
        ),
      }

    //  {
    //   label: "Action",
    //   key: "edit",
    //   cellContent: (row: any) => (
    //     <span className="d-flex justify-content-center align-items-center gap-4 cursor-pointer">
    //      <span className="text-danger"
    //       onClick={() => handleDelete(row)} >
    //       <i className="fa-solid fa-trash"></i>
    //     </span>
    //     </span>
    //   ),
    // },
    ];
    return (
      <div className="dashboard-body">
        <div className="container-fluid">
          <ToastContainer
          autoClose={2000}
          />
          <div className="row">
            <div className="col-md-12">
              <div className="d-main-title">
                <h3>
                  <i className="mx-2">
                    <i className="fa-solid fa-user-plus"></i>
                  </i>
                Add New User
                </h3>
              </div>
            </div>
            <div className="col-md-12">
              <div className="main-card mt-5">
                <div className="dashboard-wrap-content p-2">
                  <div className="d-md-flex flex-wrap align-items-center">
                    <div className="dashboard-date-wrap mt-4">
                      <div className="form-group">
                        {/* <div className="relative-input position-relative">
                          <input
                          className="form-control h_40"
                            type="text"
                            placeholder="Search by name"
                              value={search}
                              onChange={(e) => handleSearch(e)}
                          />
                          <i className="uil uil-search"></i>
                        </div> */}
                      </div>
                    </div>
                    <div className="rs ms-auto mt-2 mt_r4">
                      <div className="">
                          <Button color="danger" onClick={toggle}>
                          <i className="fa-solid fa-plus"></i>
                          <span className="me-2"> New User</span>
                        </Button> 
                        <Modal isOpen={modal} toggle={toggle}>
                          <ModalHeader toggle={toggle}>Add New User</ModalHeader>
                            <ModalBody className="p-4">
                                <Form onSubmit={formik.handleSubmit}>
                                <FormGroup>
                                    <Label for="name">Name</Label>
                                    <Input
                                    type="text"
                                    name="name"
                                    id="name"
                                    placeholder="Enter user name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    invalid={formik.touched.name && !!formik.errors.name}
                                    />
                                    <FormFeedback>{formik.errors.name}</FormFeedback>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Enter user email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    invalid={formik.touched.email && !!formik.errors.email}
                                    />
                                    <FormFeedback>{formik.errors.email}</FormFeedback>
                                </FormGroup>
                                <FormGroup> 
                                    <Label for="phoneNo">Phone Number</Label>
                                    <Input 
                                    type="text"
                                    name="phoneNo"
                                    id="phoneNo"
                                    placeholder="Enter user phone number"
                                    value={formik.values.phoneNo}
                                    onChange={formik.handleChange}
                                    invalid={formik.touched.phoneNo && !!formik.errors.phoneNo}
                                    />
                                    <FormFeedback>{formik.errors.phoneNo}</FormFeedback>
                                </FormGroup>
                               <FormGroup>
                                  <Label for="venue">Venue</Label>
                                  <Input
                                    type="select"
                                    name="venue"
                                    id="venue"
                                    value={formik.values.venue}
                                    onChange={formik.handleChange}
                                    invalid={formik.touched.venue && !!formik.errors.venue}
                                  >
                                    <option value="">Select a venue</option>
                                    {eventVenuesForAdd.map((venue: any) => (
                                      <option key={venue.value} value={venue.value}>
                                        {venue.label}
                                      </option>
                                    ))}
                                  </Input>
                                  <FormFeedback>{formik.errors.venue}</FormFeedback>
                                </FormGroup>
                                {/* <FormGroup>
                                  <Label for="status">Status</Label>
                                  <Input
                                    type="select"
                                    name="status"
                                    id="status"
                                    value={formik.values.status}
                                    onChange={formik.handleChange}
                                    invalid={formik.touched.status && !!formik.errors.status}

                                  >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                  </Input>
                                  <FormFeedback>{formik.errors.status}</FormFeedback>
                                </FormGroup> */}
                                {/* <FormGroup>
                                  <Label for="profileImage">Profile Image</Label>
                                  {formik.values.profileImage  && (
                                    <img
                                      src={URL.createObjectURL(formik.values.profileImage)}
                                      alt="Preview"
                                      style={{ width: "100px", height: "100px", objectFit: "cover", marginTop: 8 }}
                                    />
                                  )}
                                  <Input
                                    type="file"
                                    name="profileImage"
                                    id="profileImage"
                                    onChange={(event) => {
                                      const file = event.currentTarget.files?.[0];
                                      if (file) {
                                        formik.setFieldValue("profileImage", file);
                                        formik.setTouched({ ...formik.touched, profileImage: true });
                                      }
                                    }}
                                    invalid={formik.touched.profileImage && !!formik.errors.profileImage}
                                    
                                  />
                                  <FormFeedback>{formik.errors.profileImage}</FormFeedback>
                                </FormGroup> */}

                                <FormGroup>
                                  <Label for="password">Password</Label>
                                  <div className="position-relative">
                                    <Input
                                      type={showPassword ? "text" : "password"}
                                      name="password"
                                      id="password"
                                      placeholder="Enter user password"
                                      value={formik.values.password}
                                      onChange={formik.handleChange}
                                      invalid={formik.touched.password && !!formik.errors.password}
                                    />
                                    <i
                                      className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} position-absolute`}
                                      style={{ top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}
                                      onClick={() => setShowPassword((prev) => !prev)}
                                      title={showPassword ? "Hide Password" : "Show Password"}
                                    ></i>
                                  </div>
                                  <FormFeedback>{formik.errors.password}</FormFeedback>
                                </FormGroup>
                                 <ModalFooter>
                                <Button color="primary" type="submit">Add User</Button>
                               </ModalFooter>
                                </Form>
                            </ModalBody>
                        </Modal>
                        <Modal isOpen={editModal} toggle={toggleEditModal}>
                          <ModalHeader toggle={toggleEditModal}>Edit User</ModalHeader>
                          <ModalBody className="p-4">
                            <Form onSubmit={editFormik.handleSubmit}>
                              <FormGroup>
                                <Label for="phoneNo">Phone Number</Label>
                                <Input
                                  type="text"
                                  name="phoneNo"
                                  id="phoneNo"
                                  value={editFormik.values.phoneNo}
                                  onChange={editFormik.handleChange}
                                  invalid={editFormik.touched.phoneNo && !!editFormik.errors.phoneNo}
                                />
                                <FormFeedback>{editFormik.errors.phoneNo}</FormFeedback>
                              </FormGroup>

                              <FormGroup>
                                <Label for="status">Status</Label>
                                <Input
                                  type="select"
                                  name="status"
                                  id="status"
                                  value={editFormik.values.status}
                                  onChange={editFormik.handleChange}
                                  invalid={editFormik.touched.status && !!editFormik.errors.status}
                                >
                                  <option value="">Select status</option>
                                  <option value="active">Active</option>
                                  <option value="inactive">Inactive</option>
                                </Input>
                                <FormFeedback>{editFormik.errors.status}</FormFeedback>
                              </FormGroup>

                              <ModalFooter>
                                <Button color="primary" type="submit">Update</Button>
                                <Button color="secondary" onClick={toggleEditModal}>Cancel</Button>
                              </ModalFooter>
                            </Form>
                          </ModalBody>
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {isLoading ? (
                <div className="d-flex justify-content-center py-4">
                  <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
                </div>
              ) : (
                // <div className="event-list">
                //   <div className="tab-content">
                //     <div
                //       className="tab-pane fade show active"
                //       id="orders-tab"
                //       role="tabpanel"
                //     >
                //       <NormalTable columns={columns} data={user} getRowId={(row: any) => row.userId} />
                //     </div>
                //   </div>
                // </div>
                <div className="mt-4 ">
                  {user.length === 0 && !isLoading && (
                    <p className="text-center w-100">No users found.</p>
                  )}

                  {user.map((item: any) => (
                    <div key={item.userId}>
                      <ListCard
                        cardData={{
                          name: item.name,
                          icon: "fa-solid fa-user", 
                          ticket: item.email,
                          startDate: item.createdAt,
                          status: item.status,
                          description: item.phoneNo,
                          optionHead: "Venue",
                          option: item.venue?.venueName || "N/A",
                        }}
                        onEdit={() => {
                          setSelectedUser(item);
                          editFormik.setValues({
                            phoneNo: item.phoneNo,
                            status: item.status,
                          });
                          toggleEditModal();
                        }}
                        onDelete={async () => {
                          if (window.confirm("Are you sure you want to delete this user?")) {
                            try {
                              await deleteUser(item.userId);
                              toast.success("User deleted successfully");
                              getUserList();
                            } catch (error) {
                              toast.error("Failed to delete user");
                            }
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
    };
export default AddNewUser;  